import { CampusWard } from './campus-ward.model';
import { SortableChurchUnit } from './sortable-church-unit.model';

export class LocalWard {
    campusHomeWardId: number; // primary key
    localUnit: SortableChurchUnit;
    campusWard: CampusWard;
}
